import { useNavigate } from 'react-router-dom-v5-compat'
import { InfoButton } from 'components/buttons'
import { SectionHeading } from 'components/headings'
import HolidayOrnamnet from 'shared/svg/holiday-ornament.svg'
import HolidayMenorah from 'shared/svg/holiday-menorah.svg'
import HolidayPresent from 'shared/svg/holiday-present.svg'
import Slide from '../slide/slide'

interface CelebrateHolidayProps {
  holiday: string
  onNext: (data: any) => void
  nextPath: string
}

export const CelebrateHoliday = ({
  holiday,
  onNext,
  nextPath,
}: CelebrateHolidayProps) => {
  const navigate = useNavigate()

  const isChristmas = holiday.toLowerCase() === 'christmas'
  const isHanukkah = holiday.toLowerCase() === 'hanukkah'

  const handleNext = () => {
    onNext({ list_sub_type: holiday.toLowerCase() })
    navigate(nextPath)
  }

  const HolidayIcon = () => {
    if (isChristmas) return <HolidayOrnamnet />
    if (isHanukkah) return <HolidayMenorah />

    return <HolidayPresent />
  }

  const CelebrationMessage = () => {
    if (isChristmas) return "Santa's workshop is open!"
    if (isHanukkah) return 'Eight nights, endless wishes!'
    return 'Let the gifting begin!'
  }

  return (
    <Slide>
      <HolidayIcon />
      <SectionHeading className="text-center" style={{ maxWidth: 600 }}>
        {CelebrationMessage()}
      </SectionHeading>
      <InfoButton
        pill
        className="mtl"
        style={{ minWidth: 230 }}
        onClick={handleNext}
      >
        Next
      </InfoButton>
    </Slide>
  )
}
